// Mobile Menu
const navLinks = document.getElementById('navLinks')
const faClose = document.querySelector('.fa-close')
const faBars = document.querySelector('.fa-bars')

const showMenu = () => {
    navLinks.style.right = "0";
}

const hideMenu = () => {
    navLinks.style.right = "-200px";
}

faClose.addEventListener('click',hideMenu)
faBars.addEventListener('click',showMenu)